// extracted by mini-css-extract-plugin
module.exports = {"card":"cardFund_card__18BhC","cardLeft":"cardFund_cardLeft__3npn0","cardTitle":"cardFund_cardTitle__28vBF","arrow":"cardFund_arrow__3jTo0"};